import { formatCurrency } from '../../utils/formatters';
import { saleMetaLine } from '../../utils/salesHistory';

/**
 * Land Registry recent-sales list with deed metadata and same-day dual-transfer notes.
 * Professionals need to justify divergent figures for the same address/date.
 */
export default function SalesHistoryList({ sales = [], limit = 10, className = '' }) {
  const rows = sales.slice(0, limit);
  if (!rows.length) return null;

  // Show each unique price_note once, under the first row that carries it.
  const seenNotes = new Set();

  return (
    <div className={`space-y-2 ${className}`}>
      {rows.map((s, i) => {
        const note = s.price_note;
        const showNote = note && !seenNotes.has(note);
        if (showNote) seenNotes.add(note);
        const key = s.id ?? `${s.address}-${s.sale_date}-${s.sale_price}-${i}`;

        return (
          <div key={key}>
            <div className="flex items-center justify-between gap-3 bg-slate-900/50 rounded-lg px-4 py-2.5">
              <div className="min-w-0">
                <div className="text-sm text-white truncate">{s.address}</div>
                <div className="text-xs text-slate-500">{saleMetaLine(s)}</div>
              </div>
              <span className="text-sm font-bold text-emerald-400 shrink-0">
                {formatCurrency(s.sale_price)}
              </span>
            </div>
            {showNote && (
              <p className="mt-1.5 mb-1 px-1 text-xs text-amber-200/90 leading-relaxed">
                {note}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
